export default import.meta.ROLLUP_FILE_URL_yxtg_yJ_Zi8pVKxOPq02BA